import _dictionary from "./fr-FR";

export default function(text) {

	var translation = _dictionary[text];
	if (translation) {
    	return translation;
	}
	else {
    	console.warn("Warning: missing translation for : " + text);
    	return text;
	}
}



// WEBPACK FOOTER //
// ./src/js/common/translation/index.js